import cx from 'classnames';
import { MouseEventHandler, PropsWithChildren } from 'react';

import styles from './table.module.scss';

interface Props extends PropsWithChildren {
  className?: string;
  onClick?: MouseEventHandler<HTMLTableRowElement>;
}

export const TableRow = ({ children, className, onClick }: Props) => {
  return (
    <tr className={cx(styles.row, className, { [styles.clickable]: !!onClick })} onClick={onClick}>
      {children}
    </tr>
  );
};
